export { default as FilterCategoriesPopover } from './FilterCategoriesPopover';
